export const languages = [
    { value: 'es', text: "Español", icon: '../../../assets/icons/es.png' },
    { value: 'en', text: "English", icon: '../../../assets/icons/en.png' },
    { value: 'pt', text: "Portugués", icon: '../../../assets/icons/pt.png' }
]